module.exports = __webpack_public_path__ + "app/kiss-order/detail/order-detail-invoices-2w0WZvlM.html";